"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _RichTextEditor = _interopRequireDefault(require("lead-flows-ui/components/common/RichTextEditor"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UITileSection = _interopRequireDefault(require("UIComponents/tile/UITileSection"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _LawfulBasisSelect = _interopRequireDefault(require("ui-gdpr-components/components/LawfulBasisSelect"));

var _LegalConsent = require("lead-flows-ui/constants/LegalConsent");

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var GDPREditor =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(GDPREditor, _Component);
  (0, _createClass2.default)(GDPREditor, null, [{
    key: "propTypes",
    get: function get() {
      return {
        addCheckbox: _react.default.PropTypes.func.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        allGates: _react.default.PropTypes.array.isRequired,
        closeGDPREditor: _react.default.PropTypes.func.isRequired,
        deleteCheckbox: _react.default.PropTypes.func.isRequired,
        legalConsentOptions: _react.default.PropTypes.object,
        legalConsentDefaultSettings: _react.default.PropTypes.object,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        subscriptionsDefinitions: _react.default.PropTypes.array.isRequired,
        updateLegalConsent: _react.default.PropTypes.func.isRequired,
        validation: _react.default.PropTypes.object.isRequired,
        locale: _react.default.PropTypes.string.isRequired
      };
    }
  }]);

  function GDPREditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GDPREditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GDPREditor).call(this, props));
    _this.buildHandler = _this.buildHandler.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSubscriptionTypeOptions = _this.getSubscriptionTypeOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.buildhandlerCheckboxSubscription = _this.buildhandlerCheckboxSubscription.bind((0, _assertThisInitialized2.default)(_this));
    _this.buildhandlerCheckboxLabel = _this.buildhandlerCheckboxLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.buildDeleteHandler = _this.buildDeleteHandler.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GDPREditor, [{
    key: "buildHandler",
    value: function buildHandler(inputType) {
      var _this2 = this;

      var _this$props = this.props,
          addValidationError = _this$props.addValidationError,
          legalConsentOptions = _this$props.legalConsentOptions,
          updateLegalConsent = _this$props.updateLegalConsent,
          removeValidationError = _this$props.removeValidationError;
      return function (value) {
        if (inputType !== 'processingConsentFooterText' && !value.plainText) {
          addValidationError(inputType, _this2.langKey('fieldsMissing'));
        } else {
          removeValidationError(inputType);
        }

        updateLegalConsent(Object.assign({}, legalConsentOptions, (0, _defineProperty2.default)({}, inputType, value.html)));
      };
    }
  }, {
    key: "buildhandlerCheckboxSubscription",
    value: function buildhandlerCheckboxSubscription(idx) {
      var _this3 = this;

      return function (_ref) {
        var value = _ref.target.value;
        var _this3$props = _this3.props,
            legalConsentOptions = _this3$props.legalConsentOptions,
            updateLegalConsent = _this3$props.updateLegalConsent,
            legalConsentDefaultSettings = _this3$props.legalConsentDefaultSettings,
            locale = _this3$props.locale;
        var defaultCheckbox = legalConsentDefaultSettings.getCommunicationConsentCheckbox(locale);
        var label = defaultCheckbox.label;

        if (value !== defaultCheckbox.communicationTypeId) {
          label = legalConsentDefaultSettings.getCommunicationConsentCheckboxDefaultLabel(locale);
        }

        var legalConsentOptionsCopy = (0, _extends2.default)({}, legalConsentOptions);
        legalConsentOptionsCopy.communicationConsentCheckboxes[idx].label = label;
        legalConsentOptionsCopy.communicationConsentCheckboxes[idx].communicationTypeId = value;
        updateLegalConsent(legalConsentOptionsCopy, function () {
          _this3.forceUpdate();
        });
      };
    }
  }, {
    key: "buildhandlerCheckboxLabel",
    value: function buildhandlerCheckboxLabel(idx) {
      var _this4 = this;

      return function (value) {
        var _this4$props = _this4.props,
            addValidationError = _this4$props.addValidationError,
            legalConsentOptions = _this4$props.legalConsentOptions,
            updateLegalConsent = _this4$props.updateLegalConsent,
            removeValidationError = _this4$props.removeValidationError;
        var validationField = "checkBoxLabel" + idx;

        if (!value.plainText) {
          addValidationError(validationField, _this4.langKey('fieldsMissing'));
        } else {
          removeValidationError(validationField);
        }

        var legalConsentOptionsCopy = (0, _extends2.default)({}, legalConsentOptions);
        legalConsentOptionsCopy.communicationConsentCheckboxes[idx].label = value.html;
        updateLegalConsent(legalConsentOptionsCopy, function () {
          _this4.forceUpdate();
        });
      };
    }
  }, {
    key: "buildhandlerCheckboxRequired",
    value: function buildhandlerCheckboxRequired(idx) {
      var _this5 = this;

      return function (_ref2) {
        var checked = _ref2.target.checked;
        var _this5$props = _this5.props,
            legalConsentOptions = _this5$props.legalConsentOptions,
            updateLegalConsent = _this5$props.updateLegalConsent;
        var legalConsentOptionsCopy = (0, _extends2.default)({}, legalConsentOptions);
        legalConsentOptionsCopy.communicationConsentCheckboxes[idx].required = checked;
        updateLegalConsent(legalConsentOptionsCopy, function () {
          _this5.forceUpdate();
        });
      };
    }
  }, {
    key: "buildDeleteHandler",
    value: function buildDeleteHandler(idx) {
      var _this6 = this;

      return function () {
        _this6.props.deleteCheckbox(idx);
      };
    }
  }, {
    key: "getSubscriptionTypeOptions",
    value: function getSubscriptionTypeOptions() {
      var _this7 = this;

      var subscriptionsDefinitions = this.props.subscriptionsDefinitions;
      return subscriptionsDefinitions.map(function (_ref3) {
        var _ref3$category = _ref3.category,
            category = _ref3$category === void 0 ? '' : _ref3$category,
            _ref3$channel = _ref3.channel,
            channel = _ref3$channel === void 0 ? '' : _ref3$channel,
            id = _ref3.id,
            name = _ref3.name;
        var maybeHelp = channel.length && category.length ? {
          help: _I18n.default.text(_this7.langKey('subscriptionTypeHelp'), {
            category: category,
            channel: channel
          })
        } : {};
        return (0, _extends2.default)({
          text: name
        }, maybeHelp, {
          value: id
        });
      });
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowFormEditor.legalEditor." + suffix;
    }
  }, {
    key: "maybeRenderCommunicationConsent",
    value: function maybeRenderCommunicationConsent() {
      var _this$props2 = this.props,
          allGates = _this$props2.allGates,
          legalConsentOptions = _this$props2.legalConsentOptions,
          validation = _this$props2.validation;
      var communicationConsentText = legalConsentOptions.communicationConsentText,
          isLegitimateInterest = legalConsentOptions.isLegitimateInterest;
      if (isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        error: validation.communicationConsentText,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('communicationConsentHeader')
        }),
        validationMessage: validation.communicationConsentText ? _I18n.default.text(this.langKey('requiredField')) : ''
      }, _react.default.createElement(_RichTextEditor.default, {
        contents: communicationConsentText,
        gates: allGates,
        id: "communication-consent",
        onChange: this.buildHandler('communicationConsentText'),
        minHeight: 130,
        shrink: true
      }));
    }
  }, {
    key: "maybeRenderDeleteCheckbox",
    value: function maybeRenderDeleteCheckbox(idx) {
      var communicationConsentCheckboxes = this.props.legalConsentOptions.communicationConsentCheckboxes;
      if (communicationConsentCheckboxes.length === 1) return null;
      return _react.default.createElement(_UIButton.default, {
        className: "gdpr-editor__delete-checkbox",
        use: "link",
        onClick: this.buildDeleteHandler(idx)
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('deleteCheckbox')
      }));
    }
  }, {
    key: "maybeRenderRequiredToggle",
    value: function maybeRenderRequiredToggle(checkbox, idx) {
      var allGates = this.props.allGates;

      if (allGates.indexOf('GDPR:RequiredCommunicationConsent') === -1) {
        return null;
      }

      return _react.default.createElement(_UITileSection.default, {
        className: "gdpr-editor__checkbox-field__section"
      }, _react.default.createElement(_UIFormControl.default, {
        className: "display-inline-block"
      }, _react.default.createElement(_UICheckbox.default, {
        checked: checkbox.required,
        onChange: this.buildhandlerCheckboxRequired(idx),
        size: "small"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('makeRequiredField')
      }))));
    }
  }, {
    key: "maybeRenderConsentCheckboxes",
    value: function maybeRenderConsentCheckboxes() {
      var _this8 = this;

      var _this$props3 = this.props,
          addCheckbox = _this$props3.addCheckbox,
          allGates = _this$props3.allGates,
          legalConsentOptions = _this$props3.legalConsentOptions,
          validation = _this$props3.validation;
      var communicationConsentCheckboxes = legalConsentOptions.communicationConsentCheckboxes,
          isLegitimateInterest = legalConsentOptions.isLegitimateInterest;
      if (isLegitimateInterest) return null;
      return _react.default.createElement("div", {
        className: "gdpr-editor__form-field"
      }, communicationConsentCheckboxes.map(function (checkbox, idx) {
        var numb = idx ? idx + 1 : '';
        return _react.default.createElement("div", {
          className: "gdpr-editor__checkbox-field",
          key: "consent-checkbox__" + idx
        }, _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedMessage.default, {
          message: _this8.langKey('consentCheckboxesHeader'),
          options: {
            numb: numb
          }
        })), _this8.maybeRenderDeleteCheckbox(idx), _react.default.createElement(_UITile.default, null, _react.default.createElement(_UITileSection.default, {
          className: "gdpr-editor__checkbox-field__section"
        }, _react.default.createElement(_UIFormControl.default, {
          label: _react.default.createElement(_FormattedMessage.default, {
            message: _this8.langKey('subscriptionTypeHeader')
          })
        }, _react.default.createElement(_UISelect.default, {
          value: checkbox.communicationTypeId,
          onChange: _this8.buildhandlerCheckboxSubscription(idx),
          options: _this8.getSubscriptionTypeOptions()
        }))), _react.default.createElement(_UITileSection.default, {
          className: "gdpr-editor__checkbox-field__section"
        }, _react.default.createElement(_UIFormControl.default, {
          error: validation["checkBoxLabel" + idx],
          label: _react.default.createElement(_FormattedMessage.default, {
            message: _this8.langKey('checkboxLabelHeader')
          }),
          validationMessage: validation["checkBoxLabel" + idx] ? _I18n.default.text(_this8.langKey('requiredField')) : ''
        }, _react.default.createElement(_RichTextEditor.default, {
          contents: checkbox.label,
          gates: allGates,
          id: "communication-consent-checkboxes-" + idx,
          onChange: _this8.buildhandlerCheckboxLabel(idx),
          minHeight: 130,
          shrink: true
        }))), _this8.maybeRenderRequiredToggle(checkbox, idx)));
      }), _react.default.createElement(_UIButton.default, {
        className: "gdpr-editor__add-checkbox",
        use: "link",
        onClick: addCheckbox
      }, _react.default.createElement(_UIIcon.default, {
        name: "add"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('addCheckbox')
      })));
    }
  }, {
    key: "maybeRenderLawfulBasis",
    value: function maybeRenderLawfulBasis() {
      var _this$props4 = this.props,
          updateLegalConsent = _this$props4.updateLegalConsent,
          legalConsentOptions = _this$props4.legalConsentOptions;
      var isLegitimateInterest = legalConsentOptions.isLegitimateInterest,
          legitimateInterestLegalBasis = legalConsentOptions.legitimateInterestLegalBasis;
      if (!isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('lawfulBasisHeader')
        })
      }, _react.default.createElement(_LawfulBasisSelect.default, {
        hideConsent: true,
        hideContract: true,
        hideNonGdpr: true,
        formControlProps: {
          label: null // Provide our own label

        },
        value: legitimateInterestLegalBasis,
        onChange: function onChange(_ref4) {
          var value = _ref4.target.value;
          return updateLegalConsent((0, _extends2.default)({}, legalConsentOptions, {
            legitimateInterestLegalBasis: value
          }));
        }
      }));
    }
  }, {
    key: "maybeRenderProcessConsent",
    value: function maybeRenderProcessConsent() {
      var _this$props5 = this.props,
          allGates = _this$props5.allGates,
          legalConsentOptions = _this$props5.legalConsentOptions,
          validation = _this$props5.validation;
      var isLegitimateInterest = legalConsentOptions.isLegitimateInterest,
          processingConsentText = legalConsentOptions.processingConsentText;
      if (isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        error: validation.processingConsentText,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('processingConsentHeader')
        }),
        validationMessage: validation.processingConsentText ? _I18n.default.text(this.langKey('requiredField')) : ''
      }, _react.default.createElement(_RichTextEditor.default, {
        contents: processingConsentText,
        gates: allGates,
        id: "process-consent-editor",
        onChange: this.buildHandler('processingConsentText'),
        minHeight: 130,
        shrink: true
      }));
    }
  }, {
    key: "maybeRenderProcessConsentLabel",
    value: function maybeRenderProcessConsentLabel() {
      var _this$props6 = this.props,
          allGates = _this$props6.allGates,
          legalConsentOptions = _this$props6.legalConsentOptions,
          validation = _this$props6.validation;
      var isLegitimateInterest = legalConsentOptions.isLegitimateInterest,
          processingConsentType = legalConsentOptions.processingConsentType,
          processingConsentCheckboxLabel = legalConsentOptions.processingConsentCheckboxLabel;
      if (processingConsentType === _LegalConsent.ProcessingConsentType.IMPLICIT || isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        error: validation.processingConsentCheckboxLabel,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('processingConsentLabelHeader')
        }),
        validationMessage: validation.processingConsentCheckboxLabel ? _I18n.default.text(this.langKey('requiredField')) : ''
      }, _react.default.createElement(_RichTextEditor.default, {
        contents: processingConsentCheckboxLabel,
        gates: allGates,
        id: "process-consent-label",
        onChange: this.buildHandler('processingConsentCheckboxLabel'),
        minHeight: 130,
        shrink: true
      }));
    }
  }, {
    key: "maybeRenderProcessConsentFooter",
    value: function maybeRenderProcessConsentFooter() {
      var _this$props7 = this.props,
          allGates = _this$props7.allGates,
          legalConsentOptions = _this$props7.legalConsentOptions;
      var isLegitimateInterest = legalConsentOptions.isLegitimateInterest,
          processingConsentType = legalConsentOptions.processingConsentType,
          processingConsentFooterText = legalConsentOptions.processingConsentFooterText;
      if (processingConsentType === _LegalConsent.ProcessingConsentType.IMPLICIT || isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('processingConsentFooterHeader')
        })
      }, _react.default.createElement(_RichTextEditor.default, {
        contents: processingConsentFooterText,
        gates: allGates,
        id: "process-consent-footer",
        onChange: this.buildHandler('processingConsentFooterText'),
        minHeight: 130,
        shrink: true
      }));
    }
  }, {
    key: "maybeRenderSubscriptionType",
    value: function maybeRenderSubscriptionType() {
      var _this$props8 = this.props,
          updateLegalConsent = _this$props8.updateLegalConsent,
          legalConsentOptions = _this$props8.legalConsentOptions;
      var isLegitimateInterest = legalConsentOptions.isLegitimateInterest,
          legitimateInterestSubscriptionTypes = legalConsentOptions.legitimateInterestSubscriptionTypes;
      var subscriptionTypes = Array.isArray(legitimateInterestSubscriptionTypes) ? legitimateInterestSubscriptionTypes : [legitimateInterestSubscriptionTypes];
      if (!isLegitimateInterest) return null;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('legitimateInterestSubscriptionTypeHeader')
        })
      }, _react.default.createElement(_UISelect.default, {
        multi: true,
        onChange: function onChange(_ref5) {
          var value = _ref5.target.value;
          return updateLegalConsent((0, _extends2.default)({}, legalConsentOptions, {
            legitimateInterestSubscriptionTypes: value
          }));
        },
        options: this.getSubscriptionTypeOptions(),
        value: subscriptionTypes
      }));
    }
  }, {
    key: "renderBackButton",
    value: function renderBackButton() {
      var closeGDPREditor = this.props.closeGDPREditor;
      return _react.default.createElement(_UIBackButton.default, null, _react.default.createElement(_UILink.default, {
        onClick: closeGDPREditor
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('backToForm')
      })));
    }
  }, {
    key: "renderEditLink",
    value: function renderEditLink() {
      return _react.default.createElement("span", {
        className: "gdpr-editor__edit-link"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('editLink.text')
      }), _react.default.createElement(_UILink.default, {
        external: true,
        href: (0, _DynoUtils.getPrivacySettingsLink)()
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('editLink.link')
      })));
    }
  }, {
    key: "renderPrivacyPolicyText",
    value: function renderPrivacyPolicyText() {
      var _this$props9 = this.props,
          allGates = _this$props9.allGates,
          legalConsentOptions = _this$props9.legalConsentOptions,
          validation = _this$props9.validation;
      var privacyPolicyText = legalConsentOptions.privacyPolicyText;
      return _react.default.createElement(_UIFormControl.default, {
        className: "gdpr-editor__form-field",
        error: validation.privacyPolicyText,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('privacyPolicyHeader')
        }),
        validationMessage: validation.privacyPolicyText ? _I18n.default.text(this.langKey('requiredField')) : ''
      }, _react.default.createElement(_RichTextEditor.default, {
        contents: privacyPolicyText,
        gates: allGates,
        id: "privacy-policy-text",
        onChange: this.buildHandler('privacyPolicyText'),
        minHeight: 130,
        shrink: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "gdpr-editor__nav"
      }, this.renderBackButton(), this.renderEditLink()), _react.default.createElement("h2", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('header')
      })), _react.default.createElement("div", null, this.maybeRenderSubscriptionType(), this.maybeRenderCommunicationConsent(), this.maybeRenderConsentCheckboxes(), this.maybeRenderLawfulBasis(), this.maybeRenderProcessConsent(), this.maybeRenderProcessConsentLabel(), this.maybeRenderProcessConsentFooter(), this.renderPrivacyPolicyText()));
    }
  }]);
  return GDPREditor;
}(_react.Component);

exports.default = GDPREditor;
module.exports = exports.default;